/**
 * Rite Skincare — Homepage JavaScript
 * Handles: pencil banner, ingredient drawers, gallery, offer selector,
 *          delivery dropdown, qty counter, detail drawers, FAQ accordion, newsletter
 */

(function () {
  'use strict';

  /* ─── PENCIL BANNER ─────────────────────────────────────── */
  function initPencilBanner() {
    const slides = document.querySelectorAll('.rite-pencil-banner__slide');
    if (!slides.length) return;

    let current = 0;
    let timer;

    function show(index) {
      slides.forEach(s => s.classList.remove('active'));
      slides[index].classList.add('active');
      current = index;
    }

    function next() {
      show((current + 1) % slides.length);
    }

    function prev() {
      show((current - 1 + slides.length) % slides.length);
    }

    function start() {
      timer = setInterval(next, 3000);
    }

    function stop() {
      clearInterval(timer);
    }

    show(0);
    if (slides.length > 1) {
      start();
      const banner = document.getElementById('ritePencilBanner');
      if (banner) {
        banner.addEventListener('mouseenter', stop);
        banner.addEventListener('mouseleave', start);
      }
      document.querySelector('[data-banner-next]')?.addEventListener('click', () => { stop(); next(); start(); });
      document.querySelector('[data-banner-prev]')?.addEventListener('click', () => { stop(); prev(); start(); });
    }
  }


 /* ─── INGREDIENT DRAWERS ────────────────────────────────── */
/**
 * Ingredient Drawer Image Swapper
 * 
 * Functionality:
 * - Watches collapsible-section elements in the ingredients accordion
 * - Monitors aria-expanded attribute changes on triggers
 * - When a drawer opens/closes, updates the image on the right panel
 * - Supports multiple sections on same page
 */

(function() {
  'use strict';

  function initIngredientDrawers() {
    const drawers = document.querySelectorAll('#ingredientDrawers collapsible-section');
    const imgs = document.querySelectorAll('[data-ingredient-img]');
    
    if (!drawers.length || !imgs.length) return;

    /**
     * Update image based on which drawer index
     * Loop through each drawer and find which one has aria-expanded="true"
     */
    function updateActiveImage() {
      let activeIndex = 0;
      
      drawers.forEach((drawer, index) => {
        const trigger = drawer.querySelector('[aria-expanded]');
        if (trigger && trigger.getAttribute('aria-expanded') === 'true') {
          activeIndex = index;
        }
      });

      // Show active image, hide others
      imgs.forEach((img, index) => {
        if (index === activeIndex) {
          img.removeAttribute('hidden');
        } else {
          img.setAttribute('hidden', '');
        }
      });
    }

    /**
     * Watch for attribute changes on triggers (aria-expanded)
     * and the collapsible-section elements
     */
    const observerConfig = { 
      attributes: true, 
      attributeFilter: ['aria-expanded', 'open'] 
    };

    const observer = new MutationObserver(() => {
      updateActiveImage();
    });

    // Observe all triggers inside drawers
    drawers.forEach((drawer) => {
      const trigger = drawer.querySelector('[aria-expanded]');
      if (trigger) {
        observer.observe(trigger, observerConfig);
      }
      // Also observe the collapsible-section itself
      observer.observe(drawer, observerConfig);
    });

    // Initial state: first drawer open
    if (drawers[0]) {
      const trigger = drawers[0].querySelector('[aria-expanded]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }
      drawers[0].setAttribute('open', '');
    }
    
    updateActiveImage();

    /**
     * Also listen for clicks on triggers to update immediately
     */
    drawers.forEach((drawer, index) => {
      const trigger = drawer.querySelector('.wt-collapse__trigger');
      if (trigger) {
        trigger.addEventListener('click', () => {
          setTimeout(() => {
            updateActiveImage();
          }, 100);
        });
      }
    });
  }

  /**
   * Initialize on DOMContentLoaded or run immediately if already loaded
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIngredientDrawers);
  } else {
    initIngredientDrawers();
  }

  /**
   * Re-initialize when Shopify loads a new section (theme editor)
   */
  document.addEventListener('shopify:section:load', initIngredientDrawers);

})();


 

  /* ─── FAQ ACCORDION ─────────────────────────────────────── */
  function initFaqAccordion() {
    const items = document.querySelectorAll('#riteFaqs [data-faq]');
    if (!items.length) return;

    items.forEach(item => {
      const trigger = item.querySelector('[data-faq-trigger]');
      const body = item.querySelector('.rite-faq-item__body');
      const icon = trigger?.querySelector('.rite-icon-x');

      if (!trigger) return;

      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        // One open at a time
        items.forEach(i => {
          const t = i.querySelector('[data-faq-trigger]');
          const b = i.querySelector('.rite-faq-item__body');
          const ic = t?.querySelector('.rite-icon-x');
          if (t) t.setAttribute('aria-expanded', 'false');
          if (b) b.setAttribute('hidden', '');
          if (ic) ic.classList.remove('rite-icon-x--close');
        });

        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          if (body) body.removeAttribute('hidden');
          if (icon) icon.classList.add('rite-icon-x--close');
        }
      });
    });
  }

 
  /* ─── FLOATING BOTTLE ANIMATION ─────────────────────────── */
  function initFloatAnimation() {
    const bottle = document.querySelector('[data-float]');
    if (!bottle) return;

    // CSS animation handles the float; ensure it's visible
    bottle.style.willChange = 'transform';
  }

  /* ─── INTERSECTION OBSERVER for fade-in ─────────────────── */
  function initFadeIn() {
    if (!window.IntersectionObserver) return;

    const targets = document.querySelectorAll(
      '.rite-uses, .rite-ingredients, .rite-reviews, .rite-faqs, .rite-footer'
    );

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    targets.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      io.observe(el);
    });
  }

  /* ─── INIT ───────────────────────────────────────────────── */
  function init() {
    initPencilBanner();
    initIngredientDrawers();
    initFaqAccordion();
    initFloatAnimation();
    initFadeIn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
